require('../css/news.css');

document.addEventListener('DOMContentLoaded', function() {
    let imgTurf = document.querySelector('.main__content p:first-child img');
    let imgTurfSrc = imgTurf?.getAttribute('src');
    let imgTurfFinal = imgTurfSrc?.replace('/upload/', 'https://www.turfoo.fr/upload/');
    if (imgTurf) {
        imgTurf.src = imgTurfFinal;
        imgTurf.style.height = "100%";
    }

    String.prototype.trim = function (){
        return this.replace(/(^\s*)|(\s*$)/g,"");
    };
});
